"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NgDocAngularEntities = void 0;
exports.NgDocAngularEntities = ['Component', 'Directive', 'Pipe', 'Injectable', 'NgModule'];
